import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { routes } from '~/constants';
import { createStore } from '~/store/createStore';
import { Provider } from '~/store/store-context';
import { useIoContext } from '../providers/IoContext';
export function StoreProvider(props) {
    const { children, mgmtHost, apiGatewayHost, authDomain, enableAppcues, appcuesAccountId, useAuthorizationHeader = false, googleIosClientId = '', initialState, sessionTimeoutMS, initStoreApi } = props;
    const navigate = useNavigate();
    const { getNow, cookies, logBIEventOld, native } = useIoContext();
    const store = useMemo(()=>createStore({
            initialState: initialState || {},
            session: {
                mgmtHost,
                apiGatewayHost,
                authDomain,
                useAuthorizationHeader,
                googleIosClientId,
                sessionTimeoutMS,
                enableAppcues,
                appcuesAccountId
            },
            onLogout: ()=>navigate(routes.logout),
            onNoAccess: ()=>navigate(routes.noAccessPage),
            getNow,
            initStoreApi,
            getCookie: ()=>cookies.getCookie(),
            onCookieChange: ()=>cookies.trySignalAuthTokenChange(),
            onAuthTokenInResponse: (authToken)=>cookies.setAuthTokenForNative(authToken),
            onAuthTokenRevoked: ()=>cookies.clearAuthToken(),
            onBiometricStaleToken: ()=>{
                void native.biometric.invalidateOnStaleToken();
            },
            reportToSentry: (message, param)=>{
                let { fingerprint, context } = param;
                Sentry.withScope((scope)=>{
                    if (context) {
                        Object.entries(context).forEach((param)=>{
                            let [key, value] = param;
                            scope.setContext(key, value);
                        });
                    }
                    scope.setFingerprint([
                        fingerprint
                    ]);
                    Sentry.captureException(new Error(message));
                });
            },
            onLogBI: logBIEventOld
        }), // eslint-disable-next-line react-hooks-static-deps/exhaustive-deps
    []);
    return /*#__PURE__*/ _jsx(Provider, {
        value: store,
        children: children
    });
}
